<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    z-index: 10;
  }

  .modal {
    position: relative;
    top: 12px;
    width: 290px;
    margin: auto;
    max-height: 95%;
    background: white;
    border-radius: 5px;
    z-index: 100;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    overflow-x: hidden;
    overflow-y: auto;
  }

  h3 {
    padding: 1rem;
    margin: 0;
    border-bottom: 1px solid #ccc;
    font-family: 'Roboto Slab', sans-serif;
  }

  .content {
    padding: 1rem;
  }

  span.bold {
    font-weight: bold;
  }

  div.content div,
  span,
  ul,
  li {
    padding-bottom: 10px;
    text-align: left;
  }

  footer {
    padding: 1rem;
  }

  @media (min-width: 500px) {
    .modal {
      width: 450px;
    }
  }

  @media (min-width: 700px) {
    .modal {
      width: 600px;
    }
  }
</style>

<script>
  import { getContext } from 'svelte'
  import { fly, fade } from 'svelte/transition'
  import Button from './Button.svelte'

  export let title

  const closeModal = getContext('close')

  function close() {
    closeModal()
  }
</script>

<div transition:fade class="modal-backdrop" on:click="{close}">
  <div transition:fly="{{ y: 300 }}" class="modal">
    <h3>{title}</h3>
    <div class="content">
      <div>
        <span class="bold">Goal:</span>
        To have the least points at end of game.
      </div>

      <div>
        <span class="bold">How to end game:</span>
        When first player turns over all nine cards.
      </div>

      <div>
        <span class="bold">*How NOT to end game:</span>
        Once first player turns over final card, all other players are given one
        more play. If anyone beats the first player’s score, the first player is
        penalized 25 points.
      </div>

      <div>
        <span class="bold">Cards Point Value:</span>
      </div>
      <ul>
        <li>Jokers = -2pts.</li>
        <li>Kings = 0pts.</li>
        <li>Aces = 1pt.</li>
        <li># cards (2-10) = points of that numbered card</li>
        <li>Jack = 15pts.</li>
        <li>Queen = 25pts.</li>
      </ul>
      <div>
        <span class="bold">How to play:</span>
      </div>
      <ul>
        <li>
          Determine number of games to play. Player with lowest score at the end
          of the last round, wins the match. Most games will involve 9 hands. In
          the Settings you may choose each hand to be a game or choose the
          number of points in a game.
        </li>
        <li>The Computer deals nine cards to each player.</li>
        <li>
          The rest of the cards will go in a draw pile, face down, in the middle
          of the players. The dealer turns over the top card, laying it face up
          in the discard pile.
        </li>
        <li>
          The nine cards face down in front of them, in a 3x3 grid. Each player
          turns over two random cards, leaving their other seven cards face
          down.
        </li>
        <li>
          The human player will go first. Selecting their two random cards to
          turn face up and then beginning play.
        </li>
        <li>
          The current player is indicated by a green border surounding the hand.
        </li>
        <li>
          Each play consists of a player choosing a card from the face down draw
          pile or the top card in the discard pile.
        </li>
        <li>
          If the player choose a card from the draw pile, the player will use
          the card to either replace one of their face up cards or turn over a
          face down card. After play, player must place the replaced card in the
          discard pile, face up or the player may discard the card from the draw
          pile.
        </li>

        <li>
          If the player choose a card from the discard pile, the player will use
          the card to either replace one of their face up cards or turn over a
          face down card. After play, player must place the replaced card in the
          discard pile, face up.
        </li>

        <li>
          If a player gets three of the same cards in a row horizontally or
          vertically, player gets to get rid of the row. To get rid of row,
          player will stack all 3-in-a-row cards together with the additional
          card on top, and place all 4 cards in discard pile, face up, showing
          the fourth card.
        </li>
      </ul>
      <div>
        <span class="bold">Tips:</span>
      </div>
      <ul>
        <li>Getting rid of rows is key to losing points.</li>
        <li>
          Replace high valued cards quickly. You don’t want to be left with high
          pts when another player turns over their final card.
        </li>
        <li>
          Turn over cards quickly. But, do NOT turn over your final card unless
          you can be assured the computer player will have less points than you.
        </li>
        <li>
          Place your Kings and Jokers in rows that will not be replaced. Kings
          and Jokers are great cards in the end. However, make sure you don’t
          get three Jokers in a row or you will have to discard them. Always
          KEEP your jokers (in the game, not in life).
        </li>
        <li>
          Look at the cards the computer player needs. You don’t want to give it
          the cards it needs to win.
        </li>
      </ul>
    </div>
    <footer>
      <slot name="footer">
        <Button on:click="{closeModal}">Close</Button>
      </slot>
    </footer>
  </div>
</div>
